import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-deceased-name.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-deceased-name.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
import { CreateApplicationDeceasedCmConstants } from "../create-application-deceased-cm.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../../../app-controller.service";
import { AlertType } from "../../../../../../shared/models/alert";
import { AppConfig } from "../../../../../../app.config";
let EditDeceasedNameComponent = class EditDeceasedNameComponent {
    activeModal;
    appController;
    modalTitle;
    deceasedName;
    editedIndex;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    editForm;
    cancelLabel = SharedConstants.CANCEL_LABEL;
    createLabel = SharedConstants.CREATE_LABEL;
    validationMessages = CreateApplicationDeceasedCmConstants.VALIDATION_MESSAGES;
    nameLabel = CreateApplicationDeceasedCmConstants.NAME_LABEL;
    surnameLabel = CreateApplicationDeceasedCmConstants.SURNAME_LABEL;
    startDateLabel = CreateApplicationDeceasedCmConstants.START_DATE_LABEL;
    nameFormControlName = CreateApplicationDeceasedCmConstants.NAME_FORM_CONTROL_NAME;
    surnameFormControlName = CreateApplicationDeceasedCmConstants.SURNAME_FORM_CONTROL_NAME;
    startDateFormControlName = CreateApplicationDeceasedCmConstants.START_DATE_FORM_CONTROL_NAME;
    constructor(activeModal, appController) {
        this.activeModal = activeModal;
        this.appController = appController;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.editForm = new FormGroup({
            name: new FormControl(this.deceasedName.name, [Validators.required]),
            surname: new FormControl(this.deceasedName.surname, [Validators.required]),
            startDate: new FormControl(this.deceasedName.startDate)
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBtnSaveClicked($event) {
        if (this.editForm.valid) {
            this.deceasedName.name = this.editForm.get(this.nameFormControlName).value;
            this.deceasedName.surname = this.editForm.get(this.surnameFormControlName).value;
            this.deceasedName.startDate = this.editForm.get(this.startDateFormControlName).value;
            this.activeModal.close([this.editedIndex, this.deceasedName]);
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBtnCancelClicked($event) {
        this.activeModal.close(null);
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService }
    ];
    static propDecorators = {
        modalTitle: [{ type: Input }],
        deceasedName: [{ type: Input }],
        editedIndex: [{ type: Input }]
    };
};
EditDeceasedNameComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-edit-deceased-name",
        template: __NG_CLI_RESOURCE__0,
        host: { "edit-deceased-name": "create-application" },
        styles: [__NG_CLI_RESOURCE__1]
    })
], EditDeceasedNameComponent);
export { EditDeceasedNameComponent };
